export default __webpack_public_path__ + "static/media/img-13.21b7b052.jpg";